import React from "react";

export default function Footer() {
    return (
        <footer className="border-t border-white/10 bg-black/20 backdrop-blur">
            <div className="mx-auto max-w-6xl px-4 py-10 text-sm text-white/60 sm:px-6">
                <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                    <div className="flex items-center gap-2">
                        <div className="h-8 w-8 rounded-xl border border-white/10 bg-white/5" />
                        <span className="text-white/70">BotX</span>
                    </div>
                    <div className="flex flex-wrap gap-4">
                        <a className="hover:text-white" href="#">Dokumentacja</a>
                        <a className="hover:text-white" href="#">Support</a>
                        <a className="hover:text-white" href="#">Prywatność</a>
                        <a className="hover:text-white" href="#">Status</a>
                    </div>
                </div>
                <div className="mt-6 text-xs text-white/40">© {new Date().getFullYear()} BotX. All rights reserved.</div>
            </div>
        </footer>
    );
}
